
import React from "react";
import Slider from "react-slick";
import "./Hero.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function Hero() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
  };
  return (
    <div className="hero-container">
      <Slider {...settings}>
        <div>
          <img src="images/slide.png" alt="Slide 1" />
          <div className="carousel-caption">
            <h1>Welcome to PTC</h1>
            <p>Innovating Water Level Management</p>
          </div>
        </div>
        <div>
          <img src="images/slide2.png" alt="Slide 2" />
          <div className="carousel-caption">
            <h1>Automation Solutions</h1>
            <p>Smart Control Systems for Industry</p>
          </div>
        </div>
        <div>
          <img src="images/slide3.png" alt="Slide 3" />
          <div className="carousel-caption">
            <h1>Reliable Technology</h1>
            <p>Trusted Partner in Water Level Management</p>
          </div>
        </div>
      </Slider>
    </div>
  );
}

export default Hero;
